import "@fortawesome/free-regular-svg-icons";
import { VerticalTimeline } from "react-vertical-timeline-component";
import "../assets/styles/Timeline.scss";
import { MyTimelineElement } from "./TimelineElement";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <MyTimelineElement
            title="Student Software Engineering"
            employer="Steinbeis Innovation Zentrum"
            location="Stuttgart, Germany"
            date="Nov 2025-present"
            description="As a working student, I am working on the open source user interface SUSI for the Simulation Software ReSiE using TypeScript React and Reactflow."
          />
          <MyTimelineElement
            title="Master's Programm"
            employer="Hochschule der Medien"
            location="Stuttgart, Germany"
            date="Oct 2025-present"
            description="I am working on my Master's Degree in Computer Science and Media with a focus on Games, CGI, and Machine Learning"
          />
          <MyTimelineElement
            title="Augmented Reality Engineer"
            employer="Snapchat Inc."
            location="Santa Monica, USA"
            date="June 2022-Feb 2024"
            description="I worked in Lens Studio and JavaScript to create Templates, tools, prototypes and proposals for new AR features for Snapchat Filters."
          />
          <MyTimelineElement
            title="Junior Game Programmer"
            employer="Studio Seufz"
            location="Stuttgart, Germany"
            date="Sept 2020-May 2021"
            description="I built puzzles and traps in C# in Unity for the Roguelike Lucky Tower Ultimate and ported the Flash Game Moon Waltz to JavaScript."
          />
          <MyTimelineElement
            title="Bachelors in Computer Science"
            employer="Emory University"
            location="Atlanta, USA"
            date="Aug 2018-May 2022"
            description="I studied Computer Science at Emory University, graduating with a GPA of 3.9 (1,1 in the German grade system)."
          />
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
